import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import { Dropdown } from 'floating-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Dropdown',
  setup(__props) {

const shown = ref(false)

function updateShown(value: boolean) {
  shown.value = value
}

function close() {
  shown.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dropdown), _mergeProps(_ctx.$attrs, {
    class: "cursor-pointer",
    shown: shown.value,
    "onUpdate:shown": updateShown
  }), {
    popper: _withCtx(() => [
      _renderSlot(_ctx.$slots, "content", { close: close })
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", { shown: shown.value })
    ]),
    _: 3
  }, 16, ["shown"]))
}
}

})